/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Url_PlaceholderInputs */

const en_directory_vibebids_url_placeholder = /** @type {(inputs: Directory_Vibebids_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your product URL or @handle`)
};

const zh_directory_vibebids_url_placeholder = /** @type {(inputs: Directory_Vibebids_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品网址或 @账号`)
};

/**
* | output |
* | --- |
* | "Your product URL or @handle" |
*
* @param {Directory_Vibebids_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_url_placeholder = /** @type {((inputs?: Directory_Vibebids_Url_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Url_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_url_placeholder(inputs)
	return zh_directory_vibebids_url_placeholder(inputs)
});
export { directory_vibebids_url_placeholder as "directory.vibebids.url_placeholder" }